import DeleteConfirmation from "./delete-confirmation"
import UserPermissions from "./user-permissions"
import UserGroupPermissions from "./user-group-permissions"
import UsersAtRest from "./users-at-rest"
import UsersHover from "./users-hover"
import PropertyPermissions from "./property-permissions"
import PortfolioPermissions from "./portfolio-permissions"
import ObjectsAtRest from "./objects-at-rest"
import ObjectsHover from "./objects-hover"

export default {
  DeleteConfirmation,
  UserPermissions,
  UserGroupPermissions,
  UsersAtRest,
  UsersHover,
  PropertyPermissions,
  PortfolioPermissions,
  ObjectsAtRest,
  ObjectsHover
}
